import { Easing, Tween } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import AnimationClip from '../AnimationClip';
import Renderable from '../../../Component/Renderable';
import { AwaitIterators } from '../AnimationHelper';
import TransformComponent from '../../../Component/Transform';
import Point from '../../../Utility/Point';
import { DEG_TO_RAD } from 'pixi.js';
import SpriteComponent from '../../../Component/Render/Sprite';

export class ToolboxTutorialOpen extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        gameObject.getComponent(Renderable).visible = true;

        const shine: GameObject = gameObject.find('shine');
        const item: GameObject = gameObject.find('unlocked_item');
        const text: GameObject = gameObject.find('unlocked_text');
        const btnContinue: GameObject = gameObject.find(
            'continue_btn_container'
        );

        const shineElem: TransformComponent = shine.getComponent(
            TransformComponent
        );

        const itemTransform: TransformComponent = item.getComponent(
            TransformComponent
        );

        const txtRenderable: Renderable = text.getComponent(Renderable);
        txtRenderable.alpha = 0;

        const shineRenderable: SpriteComponent = shine.getComponent(
            SpriteComponent
        );
        shineRenderable.alpha = 0;

        const btnRenderable: Renderable = btnContinue.getComponent(Renderable);
        btnRenderable.alpha = 0;

        // Ray rotation loop.

        shineElem.rotation = 0;
        const tweenRotation: Tween = this.getTween(shineElem);
        tweenRotation
            .to({ rotation: DEG_TO_RAD * 360 }, 10000)
            .repeat(Infinity)
            .start(this.elapsedTime);

        itemTransform.scale = Point.Zero;
        const itemTween: Tween = this.getTween(itemTransform.scale);
        itemTween.to({ x: 1.5, y: 1.5 }, 500).easing(Easing.Back.Out);

        // Fade in.
        const txtFadeInTween: Tween = this.getTween(txtRenderable);
        txtFadeInTween.to({ alpha: 1 }, 500).start(this.elapsedTime);

        const shineFadeInTween: Tween = this.getTween(shineRenderable);
        shineFadeInTween.to({ alpha: 1 }, 500).start(this.elapsedTime);

        const btnFadeInTween: Tween = this.getTween(btnRenderable);
        btnFadeInTween.to({ alpha: 1 }, 500);

        //yield* this.startTween(btnFadeInTween);
        yield* AwaitIterators([
            this.startTween(itemTween),
            this.startTween(btnFadeInTween),
            this.startTween(shineFadeInTween),
            this.startTween(txtFadeInTween),
        ]);

        while (true) yield;
    }
}
